





import { Component, Vue } from 'vue-property-decorator';
import TcEdit from './TcEdit.vue';
import RdkmEdit from './RdkmEdit.vue';

@Component({
    components: {
    "tc-edit": TcEdit,
    "rdkm-edit": RdkmEdit
  }
})
export default class Edit extends Vue { 
  beforeRouteLeave(to: any, from: any, next: any) {
      //@ts-ignore
      next();
  }
}
